import { useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { COLORS } from "./theme";

export default function LiquidityCard({ m }) {
  const data = useMemo(
    () => [
      { name: "Current", value: Number(m.current_ratio || 0) },
      { name: "Quick", value: Number(m.quick_ratio || 0) },
      { name: "Cash", value: Number(m.cash_ratio || 0) },
    ],
    [m]
  );
  return (
    <Card className="lg:col-span-5 bg-white border-[#E5E0D8] shadow-none" data-testid="liquidity-card">
      <CardHeader className="pb-1">
        <CardDescription className="text-xs uppercase tracking-[0.18em] text-[#5C665D]">Liquidity ratios</CardDescription>
        <CardTitle className="font-serif-display text-2xl text-[#1F382E]">Coverage of short-term obligations.</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-52">
          <ResponsiveContainer>
            <BarChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
              <CartesianGrid stroke={COLORS.border} vertical={false} />
              <XAxis dataKey="name" stroke={COLORS.muted} tick={{ fontSize: 12 }} axisLine={false} tickLine={false} />
              <YAxis stroke={COLORS.muted} tick={{ fontSize: 12 }} axisLine={false} tickLine={false} />
              <Tooltip
                cursor={{ fill: "#F7F5F0" }}
                contentStyle={{ background: "#fff", border: `1px solid ${COLORS.border}`, borderRadius: 8 }}
                formatter={(v) => Number(v).toFixed(2)}
              />
              <Bar dataKey="value" fill={COLORS.primary} radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
